// extracted by mini-css-extract-plugin
export default {"star":"EjJzh_POyxnG4U1TYSOT"};